import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import TooltipIcon from '@/components/IconGroup/TooltipIcon'
import { Colours } from '@/utils/styles'

const IconContainer = styled.div`
  position: relative;
  cursor: pointer;
`

const NotificationCounter = styled.span`
  position: absolute;
  right: -10px;
  top: -10px;
  background: ${Colours.red};
  color: #fff;
  border-radius: 10px;
  font-weight: bold;
  padding: 5px;
  font-size: 10px;
  text-align: center;
  min-width: 20px;
`

interface Props {
  tooltipMessage: string
  icon: IconProp
  iconSize?: SizeProp
  onClick: () => void
  notificationCount?: number
  disabled?: boolean
  disabledIcon?: IconProp
  ariaLabel?: string
}

const getNotificationCountLabel = (notificationCount: number) =>
  notificationCount > 10 ? '10+' : notificationCount

const IconButton = ({
  tooltipMessage,
  icon,
  onClick,
  notificationCount,
  disabled = false,
  iconSize = '2x',
  disabledIcon,
  ariaLabel,
}: Props) => (
  <TooltipIcon
    icon={
      <IconContainer>
        <FontAwesomeIcon
          size={iconSize}
          icon={disabled && disabledIcon !== undefined ? disabledIcon : icon}
          onClick={() => {
            if (!disabled) {
              onClick()
            }
          }}
          aria-label={ariaLabel}
        />
        {notificationCount !== undefined && notificationCount > 0 && (
          <NotificationCounter>
            {getNotificationCountLabel(notificationCount)}
          </NotificationCounter>
        )}
      </IconContainer>
    }
    tooltipMessage={tooltipMessage}
  />
)

export default IconButton
